import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = { searchUrl: String, overrideUrl: String, paramName: { type: String, default: "pharmacy_id" } }

  connect() {
    this.timeout = null
  }

  preventSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  search() {
    clearTimeout(this.timeout)

    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      this.fetchResults(query)
    }, 200)
  }

  async fetchResults(query) {
    try {
      const response = await fetch(
        `${this.searchUrlValue}?q=${encodeURIComponent(query)}`
      )
      const pharmacies = await response.json()

      if (pharmacies.length > 0) {
        this.showResults(pharmacies)
      } else {
        this.showNoResults()
      }
    } catch (error) {
      console.error("Error fetching pharmacies:", error)
      this.hideResults()
    }
  }

  showResults(pharmacies) {
    this.resultsTarget.innerHTML = pharmacies.map(pharmacy => `
      <button type="button"
              class="w-full text-left px-3 py-2 hover:bg-slate-100 cursor-pointer border-b border-slate-100 last:border-b-0"
              data-action="click->pharmacy-search#select"
              data-pharmacy-id="${pharmacy.id}"
              data-pharmacy-name="${this.escapeHtml(pharmacy.name)}">
        <div class="font-medium text-sm text-slate-900">${this.escapeHtml(pharmacy.name)}</div>
        <div class="text-xs text-slate-500">
          ${this.escapeHtml(pharmacy.street_address)}, ${this.escapeHtml(pharmacy.city)}, ${this.escapeHtml(pharmacy.province)}
          &middot; Accreditation: ${this.escapeHtml(pharmacy.accreditation_number)}
        </div>
        ${pharmacy.has_manager
          ? '<div class="text-xs text-amber-600 mt-0.5">Already has a manager</div>'
          : '<div class="text-xs text-green-600 mt-0.5">No manager assigned</div>'
        }
      </button>
    `).join("")

    this.resultsTarget.classList.remove("hidden")
  }

  showNoResults() {
    this.resultsTarget.innerHTML = `
      <div class="px-3 py-2 text-sm text-slate-500">No pharmacies found</div>
    `
    this.resultsTarget.classList.remove("hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
    this.resultsTarget.innerHTML = ""
  }

  select(event) {
    event.preventDefault()
    const button = event.currentTarget
    const pharmacyId = button.dataset.pharmacyId

    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.overrideUrlValue

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const tokenInput = document.createElement("input")
    tokenInput.type = "hidden"
    tokenInput.name = "authenticity_token"
    tokenInput.value = csrfToken

    const pharmacyInput = document.createElement("input")
    pharmacyInput.type = "hidden"
    pharmacyInput.name = this.paramNameValue
    pharmacyInput.value = pharmacyId

    form.appendChild(tokenInput)
    form.appendChild(pharmacyInput)
    document.body.appendChild(form)
    form.submit()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
